import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import Table from "react-bootstrap/Table";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const ViewUser = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [users, setUsers] = useState([]);
    const [editUserId, setEditUserId] = useState(null);
    const [editData, setEditData] = useState({});

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        if (!storedUserType) {
            navigate("/login");
        } else {
            setUserType(storedUserType);
        }
        fetchUsers();
    }, [navigate]);

    const fetchUsers = () => {
        fetch("https://api.mitradingjp.com/fetch_users.php")
            .then(response => response.json())
            .then(data => {
                if (data.Status === "200") {
                    setUsers(data.Users);
                }
            })
            .catch(error => console.error("Error fetching users:", error));
    };

    const handleEdit = (user) => {
        setEditUserId(user.id);
        setEditData({ ...user, password: "" }); // Initialize password as empty for security
    };

    const handleChange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        fetch("https://api.mitradingjp.com/update_user.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(editData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status === "200") {
                    setEditUserId(null);
                    setEditData({});
                    fetchUsers();
                } else {
                    console.error("Error updating user:", data.Message);
                }
            })
            .catch(error => console.error("Error updating user:", error));
    };

    const handleCancel = () => {
        setEditUserId(null);
        setEditData({});
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this user?")) {
            fetch("https://api.mitradingjp.com/delete_user.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id }),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.Status === "200") {
                        fetchUsers();
                    } else {
                        console.error("Error deleting user:", data.Message);
                    }
                })
                .catch(error => console.error("Error deleting user:", error));
        }
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="adminnavbar">
                    <h1>Welcome to the Admin Panel</h1>
                    <button onClick={() => navigate("/login")} className="btn btn-danger">
                        Logout
                    </button>
                </div>

                <div className="mainsection">
                    <h3>View All Users</h3>
                </div>

                <Table className="table table-striped">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>User Type</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.length > 0 ? (
                            users.map((user) => (
                                <React.Fragment key={user.id}>
                                    <tr>
                                        <td>{user.id}</td>
                                        <td>{user.fname}</td>
                                        <td>{user.lname}</td>
                                        <td>{user.email}</td>
                                        <td>{user.usertype}</td>
                                        <td>{user.status}</td>
                                        <td>
                                            <button className="btn btn-warning btn-sm" onClick={() => handleEdit(user)}>Edit</button>
                                        </td>
                                    </tr>
                                    {editUserId === user.id && (
                                        <tr>
                                            <td colSpan="7">
                                                <div className="row mb-2">
                                                    <div className="col-lg-4">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="fname"
                                                            value={editData.fname}
                                                            onChange={handleChange}
                                                            placeholder="First Name"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="lname"
                                                            value={editData.lname}
                                                            onChange={handleChange}
                                                            placeholder="Last Name"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="email"
                                                            value={editData.email}
                                                            onChange={handleChange}
                                                            placeholder="Email"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <div className="col-lg-4">
                                                        <input
                                                            className="form-control"
                                                            type="password"
                                                            name="password"
                                                            value={editData.password}
                                                            onChange={handleChange}
                                                            placeholder="New Password (leave blank to keep unchanged)"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <select
                                                            className="form-control"
                                                            name="usertype"
                                                            value={editData.usertype}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="administrator">Administrator</option>
                                                            <option value="admin">Admin</option>
                                                            <option value="user">User</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <select
                                                            className="form-control"
                                                            name="status"
                                                            value={editData.status}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="Active">Active</option>
                                                            <option value="Pending">Pending</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <button className="btn btn-primary btn-sm mb-2" onClick={handleSave}>
                                                    Save
                                                </button>
                                                <button
                                                    className="btn btn-success btn-sm mb-2"
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={handleCancel}
                                                >
                                                    Cancel
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7">No users found</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default ViewUser;